import styled from 'styled-components';

export const ShadowContainer = styled.div`
  margin: 150px 0px 30px 0px;
  min-width: 80%;
  box-shadow: 0px 0px 10px 5px ${(props) => props.theme.colors.lightGray};
  border-radius: 7px;
  display: flex;
  justify-content: center;
  padding: 30px;
  box-sizing: border-box;
`;
